module.exports = __webpack_public_path__ + "img/promocode.3d90948b.jpg";